import React, { useEffect, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { fetchCountries } from '../../../../actions/country/countryList'
import { AppState } from '../../../../reducers'
import { CountriesState } from '../../../../reducers/country/countries'
import { Button, CircularProgress, Stack } from '@mui/material'
import Countries from '..'
import { useHistory } from 'react-router-dom'
import { SessionState, isAdmin } from '../../../../reducers/auth/session'
import Country from '../../../../models/Country'
import { roleToURLPrefix } from '../../../../App'
import { PERSON } from '../../../../models/User'
import { useTranslation } from 'react-i18next'

interface Props {
  countries: CountriesState
  session: SessionState
}

const CountryList: React.FC<Props> = ({ countries, session }) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const { t } = useTranslation('others')
  const [reading, setReading] = useState<boolean>(true)

  useEffect(() => {
    dispatch(fetchCountries(history.location.search))
    setReading(false)
  }, [dispatch, history.location.search])


  const linkToCountryCreate = () => {
    const createUrl = isAdmin(session) ? `/admin/countries/create` : `/${session.roles && roleToURLPrefix(session.roles.filter(role => role !== PERSON)[0])}/countries/create`
    history.push(createUrl)
  }

  const linkToCountryEdit = (country: Country) => {
    const editUrl = isAdmin(session) ? `/admin/countries/update/${country.id}` : `/${session.roles && roleToURLPrefix(session.roles.filter(role => role !== PERSON)[0])}/countries/update/${country.id}`
    history.push(editUrl)
  }
  return (
    <>
      {!reading && !countries.isFetching &&
        <Stack>
          <Countries
            rows={(countries.countries || []).map(s => ({ data: s }))}
            loading={countries.isFetching}
            pagination={countries.pagination || undefined}
            onClickInfo={linkToCountryEdit}
          />
        </Stack>
      }
      {!reading && !countries.isFetching &&
      <Stack display="flex" flexDirection='row' justifyContent="space-between" padding="10px">
        <Button aria-label="back" size='large' style={{ textTransform: 'none' }} onClick={linkToCountryCreate}>
          {t('add')}
        </Button>
      </Stack>}

      {(reading || countries.isFetching) &&
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <CircularProgress size={25} />
        </div>
      }
    </>
  )
}

const mapStateToProps = (state: AppState) => ({
  countries: state.countries,
  session: state.session
})

export default connect(mapStateToProps, null)(CountryList)